import React from 'react'
import {
  AlertRuleContainer,
  TextArea,
  Description,
  SettingArea
} from './sharedStyledComponents'

export function AlertRecipientIncompatible() {
  return (
    <AlertRuleContainer style={{ marginTop: '1rem', alignItems: 'baseline' }}>
      <TextArea>
        <Description>Email alert recipients</Description>
      </TextArea>
      <SettingArea style={{ fontSize: '0.75rem', fontStyle: 'italic' }}>
        Email recipients are handled by notification settings per user
      </SettingArea>
    </AlertRuleContainer>
  )
}
